import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Icônes simplifiées (remplacer par votre bibliothèque d'icônes)
const Icon = ({ name, size = 24, color = '#000', className = '', style = {} }) => {
  const iconMap = {
    'arrow-back': '⬅️',
    'star': '⭐',
    'search': '🔍',
    'filter-list': '⚙️',
    'verified': '✅',
    'category': '📁',
    'location-on': '📍',
    'directions-car': '🚗',
    'access-time': '🕒',
    'phone': '📞',
    'arrow-forward': '➡️',
    'all-inclusive': '∞',
    'engineering': '🔧',
    'handyman': '🛠️',
    'memory': '💾',
    'emergency': '🚨',
    'build': '🏗️',
    'assignment-turned-in': '📋',
    'workspace-premium': '👑',
    'schedule': '⏰',
    'comment': '💬',
    'near-me': '📍',
    'sort-by-alpha': '🔤',
    'close': '❌',
    'check': '✓',
    'closecircle': '✖️',
    'garage': '🏢',
    'search-off': '🔍❌',
    'map': '🗺️',
  };

  const iconContent = iconMap[name] || '❓';

  return (
    <span 
      className={`icon ${className}`}
      style={{
        fontSize: `${size}px`,
        color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style
      }}
    >
      {iconContent}
    </span>
  );
};

// Données fictives pour les services
const ALL_SERVICES_DATA = {
  garages: [
    {
      id: 1,
      name: 'Garage Excellence',
      address: 'Rue des Artisans, Yaoundé',
      rating: 4.8,
      reviews: 124,
      category: 'Mécanique générale',
      subCategory: 'Réparation moteur',
      image: 'https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400',
      featured: true,
      open: true,
      premium: true,
      services: ['Diagnostic', 'Réparation moteur', 'Freins', 'Climatisation'],
      distance: '2.5 km',
      priceRange: '$$',
      verified: true
    },
    {
      id: 2,
      name: 'Auto Pro Center',
      address: 'Boulevard du 20 mai, Douala',
      rating: 4.5,
      reviews: 89,
      category: 'Carrosserie & Peinture',
      subCategory: 'Peinture',
      image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400',
      featured: false,
      open: true,
      premium: true,
      services: ['Carrosserie', 'Peinture', 'Débosselage'],
      distance: '5.3 km',
      priceRange: '$$$',
      verified: true
    },
    {
      id: 3,
      name: 'Mécanicien Express',
      address: 'Quartier Briquetterie, Yaoundé',
      rating: 4.2,
      reviews: 67,
      category: 'Dépannage rapide',
      subCategory: 'Dépannage 24/7',
      image: 'https://images.unsplash.com/photo-1551836026-d5c2c5af78e4?w=400',
      featured: true,
      open: true,
      premium: false,
      services: ['Dépannage', 'Remorquage', 'Batterie'],
      distance: '1.2 km',
      priceRange: '$',
      verified: true
    },
    {
      id: 4,
      name: 'Garage Moderne',
      address: 'Bonne année, Douala',
      rating: 4.7,
      reviews: 156,
      category: 'Électronique auto',
      subCategory: 'Diagnostic électronique',
      image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400',
      featured: false,
      open: false,
      premium: true,
      services: ['Diagnostic électronique', 'Système audio', 'GPS'],
      distance: '3.8 km',
      priceRange: '$$',
      verified: true
    },
    {
      id: 5,
      name: 'Auto Service Plus',
      address: 'Nkolbisson, Yaoundé',
      rating: 4.3,
      reviews: 92,
      category: 'Entretien régulier',
      subCategory: 'Vidange & Filtres',
      image: 'https://images.unsplash.com/photo-1629450543191-1b0ddfd5c8b8?w=400',
      featured: false,
      open: true,
      premium: false,
      services: ['Vidange', 'Filtres', 'Bougies'],
      distance: '4.1 km',
      priceRange: '$',
      verified: false
    },
    {
      id: 6,
      name: 'Tech Auto Garage',
      address: 'Akwa, Douala',
      rating: 4.9,
      reviews: 203,
      category: 'Spécialiste allemand',
      subCategory: 'BMW, Mercedes, Audi',
      image: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=400',
      featured: true,
      open: true,
      premium: true,
      services: ['Marques allemandes', 'Diagnostic avancé'],
      distance: '6.2 km',
      priceRange: '$$$$',
      verified: true
    },
  ],
  centres: [
    {
      id: 1,
      name: 'Centre de Visite Technique Principal',
      address: 'PK 12, Yaoundé',
      rating: 4.6,
      reviews: 203,
      category: 'Contrôle technique',
      subCategory: 'Visite complète',
      image: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=400',
      hours: '7h30 - 17h30',
      waitTime: '30 min',
      services: ['Contrôle technique', 'Certificat', 'Contre-visite'],
      distance: '3.2 km',
      priceRange: '$$',
      capacity: 'Haute',
      appointment: true,
      verified: true
    },
    {
      id: 2,
      name: 'CTTEK Douala',
      address: 'Bonabéri, Douala',
      rating: 4.4,
      reviews: 145,
      category: 'Visite technique',
      subCategory: 'Agréé gouvernement',
      image: 'https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=400',
      hours: '8h00 - 18h00',
      waitTime: '45 min',
      services: ['Visite technique', 'Documentation'],
      distance: '7.1 km',
      priceRange: '$$$',
      capacity: 'Moyenne',
      appointment: true,
      verified: true
    },
    {
      id: 3,
      name: 'Auto Control Center',
      address: 'Mvan, Yaoundé',
      rating: 4.9,
      reviews: 278,
      category: 'Certification',
      subCategory: 'Examen complet',
      image: 'https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=400',
      hours: '7h00 - 19h00',
      waitTime: '20 min',
      services: ['Certification', 'Examen', 'Décibel'],
      distance: '2.8 km',
      priceRange: '$$',
      capacity: 'Basse',
      appointment: false,
      verified: true
    },
    {
      id: 4,
      name: 'Centre Technique Mobile',
      address: 'Mobile - Zone Urbaine',
      rating: 4.1,
      reviews: 56,
      category: 'Service mobile',
      subCategory: 'Domicile/Entreprise',
      image: 'https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400',
      hours: '24h/24 - 7j/7',
      waitTime: '1 heure',
      services: ['Mobile', 'Urgence', 'Entreprise'],
      distance: 'Variable',
      priceRange: '$$$$',
      capacity: 'Mobile',
      appointment: true,
      verified: false
    },
  ]
};

// Catégories pour filtres
const CATEGORIES = {
  garages: [
    { id: 'all', label: 'Tous', icon: 'all-inclusive' },
    { id: 'mecanique', label: 'Mécanique', icon: 'engineering' },
    { id: 'carrosserie', label: 'Carrosserie', icon: 'handyman' },
    { id: 'electronique', label: 'Électronique', icon: 'memory' },
    { id: 'depannage', label: 'Dépannage', icon: 'emergency' },
    { id: 'entretien', label: 'Entretien', icon: 'build' },
    { id: 'specialiste', label: 'Spécialiste', icon: 'star' },
  ],
  centres: [
    { id: 'all', label: 'Tous', icon: 'all-inclusive' },
    { id: 'technique', label: 'Contrôle technique', icon: 'verified' },
    { id: 'certification', label: 'Certification', icon: 'assignment-turned-in' },
    { id: 'mobile', label: 'Mobile', icon: 'directions-car' },
    { id: 'urgence', label: 'Urgence', icon: 'emergency' },
  ]
};

const AllServices = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const typeFromURL = queryParams.get('type') || 'garages';

  const [selectedType, setSelectedType] = useState(typeFromURL);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('rating');
  const [showFilters, setShowFilters] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [showPremiumOnly, setShowPremiumOnly] = useState(false);
  const [showVerifiedOnly, setShowVerifiedOnly] = useState(false);
  const [showOpenOnly, setShowOpenOnly] = useState(false);

  // Initialiser les données
  useEffect(() => {
    loadServices();
  }, [selectedType]);

  // Filtrer les services
  useEffect(() => {
    filterServices();
  }, [services, searchQuery, selectedCategory, sortBy, showPremiumOnly, showVerifiedOnly, showOpenOnly]);

  const loadServices = useCallback(() => {
    setLoading(true);
    // Simuler un chargement asynchrone
    setTimeout(() => {
      const data = ALL_SERVICES_DATA[selectedType] || [];
      setServices(data);
      setLoading(false);
    }, 500);
  }, [selectedType]);

  const filterServices = useCallback(() => {
    let filtered = [...services];

    // Filtre par recherche
    if (searchQuery) {
      filtered = filtered.filter(service =>
        service.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        service.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
        service.category.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filtre par catégorie (simplifié)
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(service =>
        service.category.toLowerCase().includes(selectedCategory)
      );
    }

    // Filtre premium
    if (showPremiumOnly) {
      filtered = filtered.filter(service => service.premium);
    }

    // Filtre vérifié
    if (showVerifiedOnly) {
      filtered = filtered.filter(service => service.verified);
    }

    // Filtre ouvert
    if (showOpenOnly && selectedType === 'garages') {
      filtered = filtered.filter(service => service.open);
    }

    // Trier les résultats
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'rating':
          return b.rating - a.rating;
        case 'reviews':
          return b.reviews - a.reviews;
        case 'distance':
          const distA = parseFloat(a.distance) || 999;
          const distB = parseFloat(b.distance) || 999;
          return distA - distB;
        case 'name':
          return a.name.localeCompare(b.name);
        default:
          return b.rating - a.rating;
      }
    });

    setFilteredServices(filtered);
  }, [services, searchQuery, selectedCategory, sortBy, showPremiumOnly, showVerifiedOnly, showOpenOnly, selectedType]);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    loadServices();
    setTimeout(() => setRefreshing(false), 1000);
  }, [loadServices]);

  const renderServiceCard = (item) => (
    <div
      key={item.id}
      className="service-card"
      style={styles.serviceCard}
      onClick={() => navigate(`/service-detail/${item.id}?type=${selectedType}`)}
    >
      <div style={styles.cardHeader}>
        <div style={styles.imageContainer}>
          <img
            src={item.image}
            style={styles.serviceImage}
            alt={item.name}
          />
          {item.featured && (
            <div style={styles.featuredBadge}>
              <Icon name="star" size={12} color="#fff" />
              <span style={styles.featuredText}>Recommandé</span>
            </div>
          )}
          {item.premium && (
            <div style={styles.premiumBadge}>
              <Icon name="workspace-premium" size={12} color="#fff" />
            </div>
          )}
        </div>

        <div style={styles.serviceInfo}>
          <div style={styles.nameRow}>
            <span style={styles.serviceName}>
              {item.name}
            </span>
            {item.verified && (
              <Icon name="verified" size={16} color="#3b82f6" />
            )}
          </div>

          <div style={styles.categoryRow}>
            <div style={styles.categoryTag}>
              <Icon name="category" size={12} color="#64748b" />
              <span style={styles.categoryText}>{item.category}</span>
            </div>
            <span style={styles.priceRange}>{item.priceRange}</span>
          </div>

          <div style={styles.addressRow}>
            <Icon name="location-on" size={14} color="#94a3b8" />
            <span style={styles.addressText}>
              {item.address}
            </span>
          </div>

          <div style={styles.statsRow}>
            <div style={styles.ratingContainer}>
              <Icon name="star" size={14} color="#fbbf24" />
              <span style={styles.ratingText}>{item.rating}</span>
              <span style={styles.reviewsText}>({item.reviews})</span>
            </div>

            {item.distance && (
              <div style={styles.distanceContainer}>
                <Icon name="directions-car" size={12} color="#64748b" />
                <span style={styles.distanceText}>{item.distance}</span>
              </div>
            )}

            {selectedType === 'garages' && (
              <div style={{
                ...styles.statusContainer,
                backgroundColor: item.open ? '#d1fae5' : '#fee2e2'
              }}>
                <div style={{
                  ...styles.statusDot,
                  backgroundColor: item.open ? '#10b981' : '#ef4444'
                }} />
                <span style={{
                  ...styles.statusText,
                  color: item.open ? '#10b981' : '#ef4444'
                }}>
                  {item.open ? 'Ouvert' : 'Fermé'}
                </span>
              </div>
            )}

            {selectedType === 'centres' && item.waitTime && (
              <div style={styles.waitTimeContainer}>
                <Icon name="access-time" size={12} color="#3b82f6" />
                <span style={styles.waitTimeText}>{item.waitTime}</span>
              </div>
            )}
          </div>

          {item.services && (
            <div style={styles.servicesContainer}>
              {item.services.slice(0, 3).map((service, index) => (
                <div key={index} style={styles.serviceTag}>
                  <span style={styles.serviceTagText}>{service}</span>
                </div>
              ))}
              {item.services.length > 3 && (
                <span style={styles.moreServicesText}>
                  +{item.services.length - 3}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      <div style={styles.cardFooter}>
        <button
          style={styles.detailsButton}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/service-detail/${item.id}?type=${selectedType}`);
          }}
        >
          <span style={styles.detailsButtonText}>Voir détails</span>
          <Icon name="arrow-forward" size={14} color="#fff" />
        </button>

        <button 
          style={styles.contactButton}
          onClick={(e) => {
            e.stopPropagation();
            // Simuler un appel téléphonique
            alert(`Appeler ${item.name} - Fonctionnalité à implémenter`);
          }}
        >
          <Icon name="phone" size={16} color="#3b82f6" />
          <span style={styles.contactButtonText}>Appeler</span>
        </button>
      </div>
    </div>
  );

  const renderCategoryItem = (item) => (
    <button
      key={item.id}
      style={{
        ...styles.categoryItem,
        ...(selectedCategory === item.id && styles.categoryItemActive)
      }}
      onClick={() => setSelectedCategory(item.id)}
    >
      <Icon
        name={item.icon}
        size={20}
        color={selectedCategory === item.id ? '#fff' : '#64748b'}
      />
      <span style={{
        ...styles.categoryTextItem,
        ...(selectedCategory === item.id && styles.categoryTextItemActive)
      }}>
        {item.label}
      </span>
    </button>
  );

  const FilterModal = () => {
    if (!showFilters) return null;

    return (
      <div style={styles.modalOverlay} onClick={() => setShowFilters(false)}>
        <div 
          style={styles.modalContent}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={styles.modalHeader}>
            <span style={styles.modalTitle}>Filtres</span>
            <button 
              onClick={() => setShowFilters(false)}
              style={styles.closeButton}
            >
              <Icon name="close" size={24} color="#1e293b" />
            </button>
          </div>

          <div style={styles.modalBody}>
            {/* Type de service */}
            <div style={styles.filterSection}>
              <span style={styles.filterTitle}>Type de service</span>
              <div style={styles.typeButtons}>
                <button
                  style={{
                    ...styles.typeButton,
                    ...(selectedType === 'garages' && styles.typeButtonActive)
                  }}
                  onClick={() => setSelectedType('garages')}
                >
                  <Icon
                    name="garage"
                    size={20}
                    color={selectedType === 'garages' ? '#fff' : '#64748b'}
                  />
                  <span style={{
                    ...styles.typeButtonText,
                    ...(selectedType === 'garages' && styles.typeButtonTextActive)
                  }}>
                    Garages
                  </span>
                </button>
                <button
                  style={{
                    ...styles.typeButton,
                    ...(selectedType === 'centres' && styles.typeButtonActive)
                  }}
                  onClick={() => setSelectedType('centres')}
                >
                  <Icon
                    name="verified"
                    size={20}
                    color={selectedType === 'centres' ? '#fff' : '#64748b'}
                  />
                  <span style={{
                    ...styles.typeButtonText,
                    ...(selectedType === 'centres' && styles.typeButtonTextActive)
                  }}>
                    Centres
                  </span>
                </button>
              </div>
            </div>

            {/* Options de filtrage */}
            <div style={styles.filterSection}>
              <span style={styles.filterTitle}>Options</span>
              <div style={styles.filterOptions}>
                <button
                  style={styles.filterOption}
                  onClick={() => setShowPremiumOnly(!showPremiumOnly)}
                >
                  <div style={{
                    ...styles.checkbox,
                    ...(showPremiumOnly && styles.checkboxChecked)
                  }}>
                    {showPremiumOnly && <Icon name="check" size={14} color="#fff" />}
                  </div>
                  <span style={styles.filterOptionText}>Premium uniquement</span>
                  <Icon name="workspace-premium" size={16} color="#f68a3b" />
                </button>

                <button
                  style={styles.filterOption}
                  onClick={() => setShowVerifiedOnly(!showVerifiedOnly)}
                >
                  <div style={{
                    ...styles.checkbox,
                    ...(showVerifiedOnly && styles.checkboxChecked)
                  }}>
                    {showVerifiedOnly && <Icon name="check" size={14} color="#fff" />}
                  </div>
                  <span style={styles.filterOptionText}>Vérifiés uniquement</span>
                  <Icon name="verified" size={16} color="#3b82f6" />
                </button>

                {selectedType === 'garages' && (
                  <button
                    style={styles.filterOption}
                    onClick={() => setShowOpenOnly(!showOpenOnly)}
                  >
                    <div style={{
                      ...styles.checkbox,
                      ...(showOpenOnly && styles.checkboxChecked)
                    }}>
                      {showOpenOnly && <Icon name="check" size={14} color="#fff" />}
                    </div>
                    <span style={styles.filterOptionText}>Ouverts maintenant</span>
                    <Icon name="schedule" size={16} color="#10b981" />
                  </button>
                )}
              </div>
            </div>

            {/* Trier par */}
            <div style={styles.filterSection}>
              <span style={styles.filterTitle}>Trier par</span>
              <div style={styles.sortOptions}>
                {[
                  { id: 'rating', label: 'Meilleures notes', icon: 'star' },
                  { id: 'reviews', label: 'Plus d\'avis', icon: 'comment' },
                  { id: 'distance', label: 'Plus proche', icon: 'near-me' },
                  { id: 'name', label: 'Nom A-Z', icon: 'sort-by-alpha' },
                ].map((sortOption) => (
                  <button
                    key={sortOption.id}
                    style={{
                      ...styles.sortOption,
                      ...(sortBy === sortOption.id && styles.sortOptionActive)
                    }}
                    onClick={() => setSortBy(sortOption.id)}
                  >
                    <Icon
                      name={sortOption.icon}
                      size={20}
                      color={sortBy === sortOption.id ? '#3b82f6' : '#64748b'}
                    />
                    <span style={{
                      ...styles.sortOptionText,
                      ...(sortBy === sortOption.id && styles.sortOptionTextActive)
                    }}>
                      {sortOption.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div style={styles.modalFooter}>
            <button
              style={styles.resetButton}
              onClick={() => {
                setSelectedCategory('all');
                setSortBy('rating');
                setShowPremiumOnly(false);
                setShowVerifiedOnly(false);
                setShowOpenOnly(false);
              }}
            >
              <span style={styles.resetButtonText}>Réinitialiser</span>
            </button>
            <button
              style={styles.applyButton}
              onClick={() => setShowFilters(false)}
            >
              <span style={styles.applyButtonText}>Appliquer les filtres</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Styles CSS
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: '#f8fafc',
    },
    
    // Header
    header: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '12px 16px',
      backgroundColor: '#fff',
      borderBottom: '1px solid #e2e8f0',
    },
    backButton: {
      padding: '8px',
      background: 'none',
      cursor: 'pointer',
    },
    headerTitleContainer: {
      flex: 1,
      marginLeft: '8px',
    },
    headerTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1e293b',
      margin: 0,
    },
    resultsCount: {
      fontSize: '12px',
      color: '#64748b',
      marginTop: '2px',
    },
    mapButton: {
      padding: '8px',
      background: 'none',
      cursor: 'pointer',
    },
    
    // Search
    searchContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '12px 16px',
      backgroundColor: '#fff',
    },
    searchBar: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#f8fafc',
      borderRadius: '12px',
      padding: '0 16px',
      marginRight: '12px',
      height: '48px',
    },
    searchInput: {
      flex: 1,
      marginLeft: '12px',
      fontSize: '16px',
      color: '#1e293b',
      background: 'none',
      outline: 'none',
      height: '100%',
    },
    filterButton: {
      padding: '10px',
      position: 'relative',
      background: 'none',
      cursor: 'pointer',
    },
    filterBadge: {
      position: 'absolute',
      top: '2px',
      right: '2px',
      backgroundColor: '#ef4444',
      width: '18px',
      height: '18px',
      borderRadius: '9px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    filterBadgeText: {
      color: '#fff',
      fontSize: '10px',
      fontWeight: 'bold',
    },
    
    // Categories
    categoriesContainer: {
      backgroundColor: '#fff',
      borderBottom: '1px solid #e2e8f0',
      overflowX: 'auto',
    },
    categoriesList: {
      display: 'flex',
      padding: '12px 16px',
      gap: '8px',
    },
    categoryItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#f8fafc',
      padding: '8px 16px',
      borderRadius: '20px',
      border: '1px solid #e2e8f0',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
    },
    categoryItemActive: {
      backgroundColor: '#3b82f6',
      borderColor: '#3b82f6',
    },
    categoryTextItem: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#64748b',
      marginLeft: '6px',
    },
    categoryTextItemActive: {
      color: '#fff',
    },
    
    // Services list
    servicesList: {
      flex: 1,
      overflowY: 'auto',
      padding: '16px',
    },
    serviceCard: {
      backgroundColor: '#fff',
      borderRadius: '16px',
      marginBottom: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
    },
    'serviceCard:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
    cardHeader: {
      display: 'flex',
      padding: '16px',
    },
    imageContainer: {
      position: 'relative',
      flexShrink: 0,
    },
    serviceImage: {
      width: '100px',
      height: '100px',
      borderRadius: '12px',
      backgroundColor: '#f1f5f9',
      objectFit: 'cover',
    },
    featuredBadge: {
      position: 'absolute',
      top: '8px',
      left: '8px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#f68a3b',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    featuredText: {
      fontSize: '10px',
      fontWeight: 'bold',
      color: '#fff',
      marginLeft: '2px',
    },
    premiumBadge: {
      position: 'absolute',
      bottom: '8px',
      right: '8px',
      backgroundColor: '#fbbf24',
      width: '24px',
      height: '24px',
      borderRadius: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    serviceInfo: {
      flex: 1,
      marginLeft: '16px',
    },
    nameRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: '4px',
    },
    serviceName: {
      flex: 1,
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#1e293b',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    categoryRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
    },
    categoryTag: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#f1f5f9',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    categoryText: {
      fontSize: '12px',
      color: '#64748b',
      marginLeft: '4px',
    },
    priceRange: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#f68a3b',
    },
    addressRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: '12px',
    },
    addressText: {
      flex: 1,
      fontSize: '13px',
      color: '#64748b',
      marginLeft: '4px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    statsRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px',
      marginBottom: '12px',
    },
    ratingContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    ratingText: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#1e293b',
      marginLeft: '4px',
      marginRight: '2px',
    },
    reviewsText: {
      fontSize: '12px',
      color: '#94a3b8',
    },
    distanceContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#f1f5f9',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    distanceText: {
      fontSize: '12px',
      color: '#64748b',
      marginLeft: '4px',
    },
    statusContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    statusDot: {
      width: '6px',
      height: '6px',
      borderRadius: '3px',
      marginRight: '4px',
    },
    statusText: {
      fontSize: '12px',
      fontWeight: '600',
    },
    waitTimeContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#eff6ff',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    waitTimeText: {
      fontSize: '12px',
      color: '#3b82f6',
      fontWeight: '600',
      marginLeft: '4px',
    },
    servicesContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '8px',
    },
    serviceTag: {
      backgroundColor: '#f1f5f9',
      padding: '4px 8px',
      borderRadius: '6px',
    },
    serviceTagText: {
      fontSize: '11px',
      color: '#64748b',
    },
    moreServicesText: {
      fontSize: '11px',
      color: '#94a3b8',
      fontStyle: 'italic',
    },
    cardFooter: {
      display: 'flex',
      flexDirection: 'row',
      padding: '16px',
      borderTop: '1px solid #f1f5f9',
      gap: '12px',
    },
    detailsButton: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#3b82f6',
      padding: '10px',
      borderRadius: '8px',
      cursor: 'pointer',
    },
    detailsButtonText: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#fff',
      marginRight: '4px',
    },
    contactButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #3b82f6',
      cursor: 'pointer',
    },
    contactButtonText: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#3b82f6',
      marginLeft: '4px',
    },
    
    // Loading
    loadingContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    loadingText: {
      marginTop: '12px',
      fontSize: '16px',
      color: '#64748b',
    },
    
    // Empty state
    emptyContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 16px',
      textAlign: 'center',
    },
    emptyTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#1e293b',
      marginTop: '16px',
      marginBottom: '8px',
    },
    emptyText: {
      fontSize: '14px',
      color: '#64748b',
      marginBottom: '24px',
    },
    emptyButton: {
      backgroundColor: '#3b82f6',
      padding: '12px 24px',
      borderRadius: '8px',
      cursor: 'pointer',
    },
    emptyButtonText: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#fff',
    },
    
    // Modal
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: '#fff',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      maxHeight: '85vh',
      width: '100%',
      maxWidth: '500px',
      animation: 'slideUp 0.3s ease-out',
    },
    modalHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      borderBottom: '1px solid #e2e8f0',
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1e293b',
    },
    closeButton: {
      background: 'none',
      cursor: 'pointer',
      padding: 0,
    },
    modalBody: {
      padding: '20px',
      maxHeight: 'calc(85vh - 140px)',
      overflowY: 'auto',
    },
    modalFooter: {
      display: 'flex',
      flexDirection: 'row',
      padding: '20px',
      borderTop: '1px solid #e2e8f0',
      gap: '12px',
    },
    
    // Filter sections
    filterSection: {
      marginBottom: '24px',
    },
    filterTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '12px',
      display: 'block',
    },
    typeButtons: {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
    },
    typeButton: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '12px',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      gap: '8px',
      cursor: 'pointer',
      background: 'none',
    },
    typeButtonActive: {
      backgroundColor: '#3b82f6',
      borderColor: '#3b82f6',
    },
    typeButtonText: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#64748b',
    },
    typeButtonTextActive: {
      color: '#fff',
    },
    filterOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    filterOption: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '12px 0',
      cursor: 'pointer',
      background: 'none',
    },
    checkbox: {
      width: '20px',
      height: '20px',
      borderRadius: '4px',
      border: '2px solid #cbd5e1',
      marginRight: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    checkboxChecked: {
      backgroundColor: '#3b82f6',
      borderColor: '#3b82f6',
    },
    filterOptionText: {
      flex: 1,
      fontSize: '16px',
      color: '#1e293b',
      textAlign: 'left',
    },
    sortOptions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    sortOption: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '12px 16px',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      cursor: 'pointer',
      background: 'none',
    },
    sortOptionActive: {
      backgroundColor: '#eff6ff',
      borderColor: '#3b82f6',
    },
    sortOptionText: {
      flex: 1,
      fontSize: '16px',
      color: '#64748b',
      marginLeft: '12px',
      textAlign: 'left',
    },
    sortOptionTextActive: {
      color: '#3b82f6',
    },
    resetButton: {
      flex: 1,
      padding: '14px',
      borderRadius: '12px',
      border: '1px solid #e2e8f0',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    resetButtonText: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#64748b',
    },
    applyButton: {
      flex: 2,
      padding: '14px',
      borderRadius: '12px',
      backgroundColor: '#3b82f6',
      cursor: 'pointer',
    },
    applyButtonText: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#fff',
    },
    
    // Floating button
    addButton: {
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      width: '56px',
      height: '56px',
      borderRadius: '28px',
      backgroundColor: '#3b82f6',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
      zIndex: 100,
    },
    
    // Animation
    '@keyframes slideUp': {
      from: {
        transform: 'translateY(100%)',
      },
      to: {
        transform: 'translateY(0)',
      },
    },
    
    // Refresh animation
    refreshIndicator: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
    },
  };

  // Animation pour le refresh
  const refreshAnimation = `
    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
    
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `;

  return (
    <div style={styles.container}>
      <style>{refreshAnimation}</style>
      
      {/* Header */}
      <div style={styles.header}>
        <button 
          style={styles.backButton}
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow-back" size={24} color="#1e293b" />
        </button>
        <div style={styles.headerTitleContainer}>
          <div style={styles.headerTitle}>
            {selectedType === 'garages' ? 'Tous les garages' : 'Centres de visite'}
          </div>
          <div style={styles.resultsCount}>
            {filteredServices.length} {filteredServices.length === 1 ? 'service' : 'services'} trouvé(s)
          </div>
        </div>
        <button 
          style={styles.mapButton}
          onClick={() => navigate('/map')}
        >
          <Icon name="map" size={24} color="#3b82f6" />
        </button>
      </div>

      {/* Barre de recherche */}
      <div style={styles.searchContainer}>
        <div style={styles.searchBar}>
          <Icon name="search" size={20} color="#94a3b8" />
          <input
            style={styles.searchInput}
            placeholder={`Rechercher un ${selectedType === 'garages' ? 'garage' : 'centre'}...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery.length > 0 && (
            <button 
              onClick={() => setSearchQuery('')}
              style={{ background: 'none', cursor: 'pointer' }}
            >
              <Icon name="closecircle" size={18} color="#94a3b8" />
            </button>
          )}
        </div>
        <button
          style={styles.filterButton}
          onClick={() => setShowFilters(true)}
        >
          <Icon name="filter-list" size={24} color="#3b82f6" />
          <div style={styles.filterBadge}>
            <span style={styles.filterBadgeText}>
              {[showPremiumOnly, showVerifiedOnly, showOpenOnly, selectedCategory !== 'all'].filter(Boolean).length}
            </span>
          </div>
        </button>
      </div>

      {/* Catégories */}
      <div style={styles.categoriesContainer}>
        <div style={styles.categoriesList}>
          {CATEGORIES[selectedType].map(renderCategoryItem)}
        </div>
      </div>

      {/* Liste des services */}
      <div style={styles.servicesList}>
        {refreshing && (
          <div style={styles.refreshIndicator}>
            <div style={{
              width: '24px',
              height: '24px',
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #3b82f6',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
          </div>
        )}
        
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #3b82f6',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            <div style={styles.loadingText}>Chargement des services...</div>
          </div>
        ) : filteredServices.length > 0 ? (
          filteredServices.map(renderServiceCard)
        ) : (
          <div style={styles.emptyContainer}>
            <Icon name="search-off" size={64} color="#94a3b8" />
            <div style={styles.emptyTitle}>Aucun service trouvé</div>
            <div style={styles.emptyText}>
              Essayez de modifier vos filtres ou votre recherche
            </div>
            <button
              style={styles.emptyButton}
              onClick={() => {
                setSearchQuery('');
                setSelectedCategory('all');
              }}
            >
              <span style={styles.emptyButtonText}>Réinitialiser la recherche</span>
            </button>
          </div>
        )}
      </div>

      {/* Bouton flottant pour ajouter */}
      <button
        style={styles.addButton}
        onClick={() => navigate('/add-service')}
        title="Ajouter un service"
      >
        <span style={{ fontSize: '24px', color: '#fff' }}>+</span>
      </button>

      {/* Modal des filtres */}
      <FilterModal />
    </div>
  );
};

export default AllServices;